import { DOCUMENT } from '@angular/common';
import { HttpRequest } from '@angular/common/http';
import { Component, Inject, Input, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import {
    NbBlockScrollStrategyAdapter,
    NbToastrService,
    NbWindowRef,
    NbWindowService,
    NbWindowState,
} from '@nebular/theme';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TournamentService } from 'src/app/modules/tournament/tournament.service';
import { GamesBracketComponent } from '../games-bracket/games-bracket.component';
import TabBase from '../tab-base';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-tab-games',
    templateUrl: './games.component.html',
    styleUrls: ['./games.component.scss'],
})
export class TabGamesComponent extends TabBase implements OnInit {
    loading: boolean = false;
    estrutura: any = 1;

    /**
     * Parametros para listagem da classificação
     * @property { string } tournamentId - id do torneio
     * @property { categoryId } categoryId; - id da categoria
     */
    @Input() tournamentId: string;
    @Input() categoryId: string;

    games = [];

    // games: any;
    gamesRequest: Object = {};

    windowRef: NbWindowRef;

    @ViewChild('gamesBracketTemplate', { static: false }) gamesBracketTemplate: TemplateRef<any>;

    constructor(
        private windowService: NbWindowService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        private blockScrollStrategy: NbBlockScrollStrategyAdapter,
        private toastrService: NbToastrService,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.getGames();
    }

    private getGames() {
        this.loading = true;
        this.tournamentService.getGames(this.tournamentId, this.categoryId).subscribe(
            (response) => {
                this.loading = false;
                this.games = response;
                //console.log(response);
                this.estrutura = response[0].estrutura;

                //console.log(this.estrutura);
                // this.estrutura = response.estrutura;
            },
            () => {
                this.toastrService.danger(
                    this.translate.instant('ALERT.ERROR.DESCRIPTION'),
                    this.translate.instant('ALERT.ERROR.TITLE')
                );
            }
        );
    }

    openGameBracket() {
        this.windowRef = this.windowService.open(this.gamesBracketTemplate, {
            context: this.games,
            initialState: NbWindowState.FULL_SCREEN,
            title: 'Chave de Jogos',
            windowClass: 'games-bracket',
            buttons: {
                minimize: false,
                maximize: false,
            },
        });

        this.windowRef.stateChange.subscribe(() => {
            const backdrop = this.document.querySelector('.cdk-overlay-backdrop');
            this.renderer.removeAttribute(backdrop, 'hidden');
            // this.scrollStrategy.enable();
            this.blockScrollStrategy.enable();
        });
    }

    getGamesByBox(gameId) {
        return this.tournamentService.getGamesByBox(gameId).pipe(map((response) => response.registers.arrDados));
    }

    verifyNeedOfGameRequest(phase) {
        // se tiver dados_sub_caixa, não precisa fazer nada
        if (phase.dados_sub_caixa) return;

        // caso não tenha, precisamos requisitar os jogos na api
        this.gamesRequest[phase.game_id.id_parametro] = this.getGamesByBox(phase.game_id);
    }
}
